import { appstr } from "./appstr";
import { Globals } from "../CoreApp/Globals";

export function doIndexPreFlight(indexID) {
  if (Globals._preflightInfo == null) return;

  var scm = Globals._preflightInfo.fSCM;
  var cp = Globals._preflightInfo.fCanvasPanel;
  var plm = Globals._preflightInfo.fPLM;
  var pp = Globals._preflightInfo.fPubPanel;

  var indexSC = scm.GetIndexPageSubChart();
  var sc = indexSC.fChildren[indexID];

  if (sc != null) {
    if (!Globals._preflightInfo.fShowSCNum) {
      var scName = sc.GetSubChartName();
      var scname_lower = scName.toLowerCase();
      if (Globals._preflightInfo.fNameList.has(scname_lower))
        Globals._preflightInfo.fShowSCNum = true;
      else Globals._preflightInfo.fNameList.add(scname_lower);
    }
    cp.SwitchToSubChartByObj(sc);
    var sw = plm.GetPageWidth();
    var sh = plm.GetPageHeight();
    Globals._publishScaler.AddPage(sw, sh);
  }
  if (Globals._preflightInfo.fNumPages > 30) {
    var msg =
      appstr("loadingpages") +
      " " +
      Globals._preflightInfo.fPageIndex.toString() +
      " " +
      appstr("of") +
      " " +
      Globals._preflightInfo.fNumPages.toString();
    pp.UpdateProgress2(msg, false);
  }
  if (indexSC.fChildren.length > 0 && indexID < indexSC.fChildren.length) {
    setTimeout(function () {
      doIndexPreFlight(++indexID);
    }, 1);
  } else {
    Globals._preflightInfo.fPubPanel.DoPublishBookComplete(
      Globals._preflightInfo.fShowSCNum,
      Globals._preflightInfo.fXMLOutputType
    );
    Globals._preflightInfo = null;
  }
}
